<template>
    <div class="splide relative">
        <div class="sw-slider-arrows absolute top-0 left-0 z-0 p-0 px-[34px]">
            <div class="splide__arrows flex w-full justify-between">
                <button class="splide__arrow splide__arrow--prev">
                    <i class="sw-icons-chevron-left"></i>
                </button>
                <button class="splide__arrow splide__arrow--next">
                    <i class="sw-icons-chevron-right"></i>
                </button>
            </div>
        </div>
        <div class="splide__track relative z-20">
            <ul class="splide__list">
                <slot>
                    <li class="splide__slide"></li>
                </slot>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CalendarMiniSliderLayout'
};
</script>

<style lang="postcss">
.splide__arrow:disabled > i::before {
    @apply opacity-20;
}
</style>
